var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lang-changer"},_vm._l((_vm.langs),function(lang,i){return _c('span',{key:`Lang${i}`,staticClass:"lang",class:{'lang-active': lang.key === _vm.$i18n.locale },on:{"click":function($event){return _vm.change(lang.key)}}},[_vm._v(" "+_vm._s(_vm.$t(lang.key))+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }